import { render, staticRenderFns } from "./DocumentTemplatePreview.vue?vue&type=template&id=c4937810&scoped=true&lang=pug&"
import script from "./DocumentTemplatePreview.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplatePreview.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTemplatePreview.vue?vue&type=style&index=0&id=c4937810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4937810",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
